import styled from 'styled-components';
import { COLOR } from '@src/styles/color';

export const StyledBankInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  background-color: ${COLOR.charcoal};
  border-radius: 8px;
  padding: 16px;

  .bank-info-input {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: 8px;
    flex: 1;
    width: 100%;
  }

  .bank-info-input-item {
    height: 44px;
    flex: 1;
    .MuiOutlinedInput-root {
      flex: 1;
      width: 100%;
      background-color: ${COLOR.white};
      border-radius: 8px;
      font-size: 14px;
      line-height: 20px;
      font-weight: 400;
      color: ${COLOR.darkGray};
      outline: none;
    }
  }
`;
